import React, { useState } from 'react';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

/**
 * Botão de download de PDF.
 * Faz fetch autenticado, recebe blob, dispara download.
 */
const PdfDownloadButton = ({ endpoint, params = {}, queryString = '', label = 'Baixar PDF', filename, testId = 'pdf-download' }) => {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      const base = `${process.env.REACT_APP_BACKEND_URL}${endpoint}`;
      const sp = new URLSearchParams(queryString);
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') sp.set(k, v);
      });
      const url = sp.toString() ? `${base}?${sp.toString()}` : base;
      const token = localStorage.getItem('token');
      const { data, headers } = await axios.get(url, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });
      const blob = new Blob([data], { type: headers['content-type'] || 'application/pdf' });
      const dispMatch = (headers['content-disposition'] || '').match(/filename="?([^"]+)"?/);
      const fname = filename || dispMatch?.[1] || 'relatorio.pdf';
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fname;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
      toast.success('PDF gerado com sucesso');
    } catch (err) {
      toast.error(err.response?.status === 403 ? 'Amostra insuficiente para gerar PDF' : 'Erro ao gerar PDF');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={loading}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-xs font-medium transition-colors disabled:opacity-60"
    >
      {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileDown className="w-3.5 h-3.5" />}
      {loading ? 'Gerando...' : label}
    </button>
  );
};

export default PdfDownloadButton;
